export interface AddZipCodeModalTypes {
  show: string,
  selectedId: string,
  setOpenFrom: () => void,
}
export interface AddLevelFields {
  description: string,
}
export enum AddZipCodeFieldsEnum {
  zipCode = 'zipCode',
  stateCode = 'stateCode',
  cityCode = 'cityCode',
  countryCode = 'countryCode',
}
export const LevelTableColumns = [
  { key: 'action', label: 'Action' },
  { key: 'description', label: 'Description' },
];
export interface LevelListingInterface {
  description: string;
  id: string;
  action: string;
}
